<mat-dialog-actions class="dialog-close">
    <img src="assets/images/dialog-close.svg" alt="close" mat-dialog-close class="dialog-close-img"
        (click)="dialogClose()" (keydown.enter)="dialogClose()" (keydown.space)="dialogClose()">
</mat-dialog-actions>

<div class="dialog-content map-select-popup">
    <div class="dialog-title">
        <span>
            {{'filter_dropdowns.sel_cluster' | translate}}
        </span>
    </div>
</div>

<div class="dialog-content map-select-popup">
    <div class="dialog-form">
        <form [formGroup]="lineSelector" (ngSubmit)="onSubmit()">
            <div class="selector-wrapper common-form-field">
                <mat-form-field appearance="outline" class="selector-form-field fw">
                    <mat-label>{{'report.table_header_cluster' | translate}}</mat-label>
                    <input type="text" [matAutocomplete]="auto" formControlName="cluster"
                        (change)="valueReset('cluster')" matInput>
                    <mat-autocomplete #auto="matAutocomplete">
                        <mat-option *ngFor="let option of filteredOptions | async" (click)="onClusterChange(option)"
                            (keydown)="onClusterChange(option)" (keypress)="onClusterChange(option)"
                            (keyup)="onClusterChange(option)" [value]="option?.clusterId">
                            {{option.clusterId}}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-hint align="end" class="error" *ngIf="lineSelector?.controls?.clusterid.hasError('required')">
                        {{'report.please_select_from_list' | translate}}!
                    </mat-hint>
                </mat-form-field>
            </div>

            <div class="text-align-center">
                <button mat-raised-button [ngClass]="{'submit-btn' : lineSelector.valid}"
                    [disabled]="!lineSelector.valid" color="primary" type="submit">
                    {{'common.submit' | translate}}
                </button>
            </div>
        </form>
    </div>
</div>